import { BaseComponent } from '../core/BaseComponent';
import ThemeManager from './ThemeManager';

export class ThemeProvider extends BaseComponent {
    constructor(config) {
        super(config);
        this.theme = config.theme || ThemeManager.defaultTheme;
        this.themes = {
            light: {
                '--primary': '#2563eb',
                '--primary-light': '#60a5fa',
                '--primary-dark': '#1d4ed8',
                '--secondary': '#64748b',
                '--secondary-light': '#94a3b8',
                '--secondary-dark': '#475569',
                '--success': '#22c55e',
                '--warning': '#f59e0b',
                '--error': '#ef4444',
                '--info': '#3b82f6',
                '--background': '#ffffff',
                '--background-light': '#f8fafc',
                '--background-dark': '#f1f5f9',
                '--surface': '#ffffff',
                '--text-primary': '#1e293b',
                '--text-secondary': '#64748b',
                '--text-disabled': '#94a3b8',
                '--border': '#e2e8f0',
                '--border-light': '#f1f5f9',
                '--border-dark': '#cbd5e1'
            },
            dark: {
                '--primary': '#3b82f6',
                '--primary-light': '#60a5fa',
                '--primary-dark': '#2563eb',
                '--secondary': '#94a3b8',
                '--secondary-light': '#cbd5e1',
                '--secondary-dark': '#64748b',
                '--success': '#22c55e',
                '--warning': '#f59e0b',
                '--error': '#ef4444',
                '--info': '#3b82f6',
                '--background': '#0f172a',
                '--background-light': '#1e293b',
                '--background-dark': '#0f172a',
                '--surface': '#1e293b',
                '--text-primary': '#f8fafc',
                '--text-secondary': '#cbd5e1',
                '--text-disabled': '#64748b',
                '--border': '#334155',
                '--border-light': '#475569',
                '--border-dark': '#1e293b'
            }
        };
    }

    mounted() {
        this.applyTheme(this.theme);
        ThemeManager.setTheme(this.theme);

        this.unsubscribe = ThemeManager.onThemeChange(theme => {
            this.theme = theme;
            this.applyTheme(theme);
            this.update();
        });
    }

    unmounted() {
        this.unsubscribe?.();
    }

    getCurrentTheme() {
        return this.theme || 'light';
    }

    setTheme(themeName) {
        if (this.themes[themeName]) {
            this.theme = themeName;
            this.applyTheme(themeName);
            ThemeManager.setTheme(themeName);
            localStorage.setItem('theme', themeName);
        }
    }

    applyTheme(themeName) {
        const themeToApply = this.themes[themeName] || this.themes.light;
        const root = document.documentElement;

        // Mevcut tema değişkenlerini temizle
        Object.keys(this.themes.light).forEach(key => {
            root.style.removeProperty(key);
        });

        // Yeni tema değişkenlerini uygula
        Object.entries(themeToApply).forEach(([key, value]) => {
            root.style.setProperty(key, value);
        });

        document.body.className = `theme-${themeName}`;
    }

    createTemplate() {
        return `
            <div class="theme-provider" data-theme="${this.theme}">
                <slot></slot>
            </div>
        `;
    }

    style() {
        return `
            .theme-provider {
                display: contents;
            }
        `;
    }
}